var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenYayoyaki: () => ScreenYayoyaki
});
var import_constants = __toModule(require("../constants"));
var import_yayoyakiValue = __toModule(require("../yayoyakiValue"));
var import_screen = __toModule(require("./screen"));
class ScreenYayoyaki extends import_screen.Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    this.validateScreenYayoyaki();
    if (this.isPropagateValue()) {
      this.originalValue = this.samaData.getValue(this.screenForm.yayoyakiCurrentId)[this.navigationIndex];
    }
  }
  validateScreenYayoyaki() {
    if (!Array.isArray(this.screenForm.yayoyakisId) || this.screenForm.yayoyakisId.length === 0) {
      throw new Error("ScreenYayoyaki: yayoyakis should be an array with at least one element.");
    }
    if (!!this.screenForm.yayoyakiChildId && !this.screenForm.yayoyakiCurrentId || !this.screenForm.yayoyakiChildId && !!this.screenForm.yayoyakiCurrentId) {
      throw new Error("ScreenYayoyaki: yayoyakiChildId and yayoyakiCurrentId should be both set or both unset.");
    }
  }
  isPropagateValue() {
    if (this.screenForm.yayoyakiCurrentId) {
      return true;
    }
    return false;
  }
  propagateValue() {
    const value = this.samaData.getValue(this.screenForm.yayoyakiCurrentId)[this.navigationIndex];
    this.samaData.replaceValues(this.screenForm.yayoyakiChildId, value, this.originalValue);
  }
  cleanYayoyakis() {
    this.getYayoyakis().forEach((yayoyaki) => yayoyaki.clean());
  }
  getNext() {
    if (this.isPropagateValue()) {
      this.propagateValue();
    }
    this.cleanYayoyakis();
    return super.getNext();
  }
  getPrevious() {
    if (this.isPropagateValue()) {
      this.propagateValue();
    }
    this.cleanYayoyakis();
    return super.getPrevious();
  }
  getYayoyakis() {
    return this.screenForm.yayoyakisId.map((yayoyakiId) => {
      const yayoyakiForm = this.samaForm.getYayoyakiForm(yayoyakiId);
      return new import_yayoyakiValue.YayoyakiValue(this.samaData, this.samaForm, yayoyakiForm, this.navigationIndex);
    });
  }
  getHeaderYayoyakis() {
    if (this.getYayoyakis()) {
      return this.getYayoyakis().filter((yayoyaki) => import_constants.yayoyakiHeaderTypes.some((yayoyakiHeader) => {
        var _a;
        return ((_a = yayoyaki.getRenderForm()) == null ? void 0 : _a.type) === yayoyakiHeader;
      }));
    } else {
      return [];
    }
  }
  getBodyYayoyakis() {
    if (this.getYayoyakis()) {
      return this.getYayoyakis().filter((yayoyaki) => import_constants.yayoyakiHeaderTypes.every((yayoyakiHeader) => {
        var _a;
        return ((_a = yayoyaki.getRenderForm()) == null ? void 0 : _a.type) !== yayoyakiHeader;
      }));
    } else {
      return [];
    }
  }
  isDataValid() {
    const isValid = this.getYayoyakis().every((yayoyaki) => yayoyaki.isValid());
    if (isValid) {
      return super.isDataValid();
    }
    return isValid;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenYayoyaki
});
